var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDivider = function SvgDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1228 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#divider_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#C4C4CA",
    strokeLinecap: "round",
    d: "M0 11 10.58 1l10.581 10 10.58-10 10.582 10 10.58-10 10.58 10L74.065 1l10.581 10 10.58-10 10.581 10 10.581-10 10.581 10 10.58-10 10.581 10L158.71 1l10.58 10 10.581-10 10.581 10 10.58-10 10.581 10 10.581-10 10.58 10 10.581-10 10.581 10 10.58-10 10.581 10 10.58-10 10.581 10 10.581-10 10.58 10L328 1l10.581 10 10.58-10 10.581 10 10.581-10 10.58 10 10.581-10 10.581 10 10.58-10 10.581 10 10.58-10 10.581 10 10.581-10 10.58 10 10.581-10 10.581 10 10.58-10 10.581 10 10.581-10 10.58 10 10.581-10 10.581 10 10.58-10 10.581 10 10.58-10 10.581 10 10.581-10 10.58 10 10.581-10 10.581 10 10.58-10L656 11l11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10 11-10 11 10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "divider_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1228v12H0z"
  })))));
};
export default SvgDivider;